/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'i18n!./BaPortalResources',
	'../lib/@waca/core-client/js/core-client/utils/Lexicon'
], function(BaPortalResources, Lexicon) {
	'use strict';

	const lexicon = new Lexicon({
		data: BaPortalResources,
		allowMissing: true,
		verbose: false
	});

	return {
		/**
		 * Get the string resource for the given key and interpolation options
		 *
		 * @param key The key of the string to return
		 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
		 * @returns The string to display
		 */
		get(key, interpolationOptions) {
			const translated = lexicon.translate(key, interpolationOptions);
			if (translated !== key) {
				return translated;
			}
			return `${Lexicon.NOT_TRANSLATED} (${key})`;
		}
	};

});
